exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DateInput_input {\n    box-sizing: border-box;\n}", ""]);

// exports
